import React, { createContext, Dispatch, ReactNode, SetStateAction, useContext, useEffect, useState } from 'react';
import { Team, User, Workspace } from '@/hooks/api/models';
import { TeamLogic } from '@/hooks/api/models/logics';

type Props = {
  children: ReactNode;
};

export type TeamContextType = {
  _w_?: Workspace;
  set_w_: Dispatch<SetStateAction<Workspace | undefined>>;
  me?: User;
  setMe: Dispatch<SetStateAction<User | undefined>>;
  _t_?: Team;
  set_t_: Dispatch<SetStateAction<Team | undefined>>;
  isAdmin: boolean;
};

export const TeamContext = createContext<TeamContextType>({
  _w_: undefined,
  set_w_: () => {},
  me: undefined,
  setMe: () => {},
  _t_: undefined,
  set_t_: () => {},
  isAdmin: false,
});

export const TeamProvider = ({ children }: Props) => {
  const [_w_, set_w_] = useState<Workspace>();
  const [me, setMe] = useState<User>();
  const [_t_, set_t_] = useState<Team>();
  const [isAdmin, setIsAdmin] = useState<boolean>(false);

  useEffect(() => {
    if (_w_ && me && _t_) {
      setIsAdmin(TeamLogic.isAdmin(_w_, _t_, me));
    }
  }, [_w_, me, _t_]);

  return <TeamContext.Provider value={{ _w_, set_w_, me, setMe, _t_, set_t_, isAdmin }}>{children}</TeamContext.Provider>;
};

export const useCurrentTeam = () => {
  return useContext(TeamContext);
};
